import Vue from 'vue';
import Router from 'vue-router';
import Home from './views/Home.vue';
import store from '@/store.js';

Vue.use(Router);

const router = new Router({
    mode: 'history',
    base: process.env.BASE_URL,
    routes: [
        {
            path: '/',
            name: 'home',
            component: Home
        },
        {
            path: '/capture',
            name: 'capture',
            component: () => import('./views/Capture/Capture.vue'),
            meta: {
                authRequired: true
            }
        },
        {
            path: '/alerts',
            name: 'alerts',
            component: () => import('./views/Alerts/Alerts.vue'),
            meta: {
                authRequired: true
            }
        },
        {
            path: '/choosesurvey',
            name: 'choosesurvey',
            component: () => import('./views/Manage/Surveys/ManageSurveys.vue'),
            meta: {
                authRequired: true
            }
        },
        {
            path: '/explore',
            name: 'explore',
            component: () => import('./views/Explore/Explore.vue'),
            meta: {
                authRequired: true
            }
        },
        {
            path: '/manage',
            name: 'manage',
            component: () => import('./views/Manage/Manage.vue'),
            meta: {
                authRequired: true
            }
        },
        {
            path: '/chooseshare',
            name: 'chooseshare',
            component: () => import('./views/Manage/Shares/ManageShares.vue'),
            meta: {
                authRequired: true
            }
        },
        {
            path: '/settings',
            name: 'settings',
            component: () => import('./views/Settings/Settings.vue'),
            meta: {
                authRequired: true
            }
        },
        {
            path: '/about',
            name: 'about',
            component: () => import('./views/About.vue'),
            meta: {
                authRequired: true
            }
        },
        {
            path: '/login',
            name: 'login',
            component: () => import('./views/Login.vue')
        },
        {
            path: '/register',
            name: 'register',
            component: () => import('./views/Register.vue')
        }
    ]
});

router.beforeEach((to, from, next) => {
    if (to.matched.some(record => record.meta.authRequired)) {
        
            if (store.state.isAuthenticated === "false") {
                if (store.state.initialChecked){
                    next({               
                        path: '/login'
                    });
                }
                else {
                    next();
                }
            } else {
                next();
            }
        } else {
            next();
        }
    
});

export default router;
